import { cn } from "@devhop/ui";

type MainProps = React.HTMLAttributes<HTMLElement> & {
  fixed?: boolean;
  fluid?: boolean;
  ref?: React.Ref<HTMLElement>;
};

export function Main({ fixed, className, fluid, ...props }: MainProps) {
  return (
    <main
      data-layout={fixed ? "fixed" : "auto"}
      className={cn(
        "@container/main w-full min-w-0 px-4 py-6",

        // เมื่อ layout เป็น fixed ให้ main เป็น flex และขยายเต็มพื้นที่
        fixed && "flex grow flex-col overflow-hidden",

        // ใช้ความกว้างเต็มพื้นที่ content (รวมเมื่อ sidebar ยุบ)
        !fluid && "@7xl/content:w-full @7xl/content:max-w-none",
        className,
      )}
      {...props}
    />
  );
}
